import { render } from "./HintsMain.vue?vue&type=template&id=bb22d3bc&scoped=true"
import script from "./HintsMain.vue?vue&type=script&lang=js"
export * from "./HintsMain.vue?vue&type=script&lang=js"

import "./HintsMain.vue?vue&type=style&index=0&id=bb22d3bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb22d3bc"]])

export default __exports__